import {del, get, post, put} from "../helpers/api_helper"
import {ICrmSystem, ICrmSystemsResponse} from "../store/crmSystems/types";

export const CrmSystemService = {
    getCrmSystems: async (params?: any): Promise<ICrmSystemsResponse> => {
        return get("/crm-systems", { params });
    },

    getCrmSystem: async (id: number): Promise<ICrmSystem> => {
        return get(`/crm-systems/${id}`);
    },

    createCrmSystem: async (data: Partial<ICrmSystem>): Promise<ICrmSystem> => {
        return post("/crm-systems", data);
    },

    updateCrmSystem: async (id: number, data: Partial<ICrmSystem>): Promise<ICrmSystem> => {
        return put(`/crm-systems/${id}`, data);
    },

    deleteCrmSystem: async (id: number): Promise<void> => {
        return del(`/crm-systems/${id}`);
    },
};
